class TableService
	constructor: (count = null, onChange = null) ->
		@pageSize = 25
		@page = 1
		@count = count
		@boundaries =
			start: null
			end: null

		@onChange = onChange if typeof onChange == 'function'

		@setBoundaries()

	isShown: (itemIndex) ->
		return @boundaries.start <= itemIndex && itemIndex <= @boundaries.end

	setPageSize: (pageSize) ->
		@pageSize = pageSize
		@page = 1
		@setBoundaries()
		@onChange?()

	setPage: (page) ->
		@page = page
		@setBoundaries()
		@onChange?()

	setBoundaries: ->
		@boundaries.start = @page * @pageSize - @pageSize
		@boundaries.end = @boundaries.start + @pageSize - 1
